/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 4;
  static #APPOINTMENT_PRODUCT_ID = '9593662046447';

  static addProduct(productId) {
    // Never add the Video Shopping Appointment product
    if (String(productId) === this.#APPOINTMENT_PRODUCT_ID) {
      return;
    }

    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter(
      (id) => String(id) !== this.#APPOINTMENT_PRODUCT_ID
    );

    viewedProducts = viewedProducts.filter(
      (id) => id !== productId
    );

    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(
      this.#STORAGE_KEY,
      JSON.stringify(viewedProducts)
    );
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  static getProducts() {
    const viewedProducts = JSON.parse(
      localStorage.getItem(this.#STORAGE_KEY) || '[]'
    );

    // Remove the Video Shopping Appointment product
    return viewedProducts.filter(
      (id) => String(id) !== this.#APPOINTMENT_PRODUCT_ID
    );
  }
}

